import React from "react";
import ChatWidgetContainer from "../../components/ChatWidgetComponents/ChatWidgetContainer";
import { parseWidgetConfig } from "../../utils/widgetConfig";
import { mergeTheme } from "../../utils/theme";
import "../../styles/widget-reset.css";

const ChatWidget = () => {
  const config = parseWidgetConfig();
  const theme = mergeTheme(config.theme);

  return (
    <ChatWidgetContainer
      apiKey={config.apiKey}
      apiUrl={config.apiUrl}
      theme={theme}
    />
  );
};

export default ChatWidget;
